import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import cookie from 'js-cookie';
import _ from 'lodash';
import { SgSubmissionUtil } from 'saga-modules';

export default class SgCampaignService {
    static lookupCampaignCode(onlineCampaignCode, productType, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('quote'),
            'lookupCampaignCode', [onlineCampaignCode, productType], additionalHeaders);
    }

    static readOnlineCampaignCookie() {
        const value = cookie.get('Ecode');
        if (value !== undefined) {
            const vSplit = value.split('=');
            if (vSplit.length === 2 && vSplit[0] === 'ID') {
                return vSplit[1];
            }
        }
        return undefined;
    }

    static updateCampaignCode(updateModel, modelVM, promoCodePath) {
        const newModelVM = _.clone(modelVM);
        newModelVM.onlineCampaignCode_Ext.value = this.readOnlineCampaignCookie();
        const accountHolder = SgSubmissionUtil.getAccountHolder(newModelVM);
        if (newModelVM.onlineCampaignCode_Ext.value
            && !newModelVM.campaignCode_Ext.value
            && !accountHolder.sourceOfBusiness.value
        ) {
            this.lookupCampaignCode(newModelVM.onlineCampaignCode_Ext.value, newModelVM.baseData.productCode.value).then(
                (data) => {
                    if (data && typeof data === 'string') {
                        newModelVM.campaignCode_Ext.value = data;
                    }
                    if (newModelVM.campaignCode_Ext.value && promoCodePath) {
                        _.set(newModelVM, `${promoCodePath}.value`, false);
                    }
                    updateModel(newModelVM);
                }
            );
        }
    }
}
